import styled from '@emotion/styled';

export const StyledAnime = styled.div`
  display: flex;
  margin-left: auto;
  gap: 16px;
  align-items: center;

  opacity: 0;
  transform: translateY(-6px);
  transition:
    opacity 180ms ease,
    transform 180ms ease;

  &[data-visible='true'] {
    opacity: 1;
    transform: translateY(0);
  }
`;
